import { Navigate, useParams } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";
import { MOBILE_ENABLED_AGENT_IDS } from "@/lib/agent-catalog";

interface MobileAgentRouteRedirectProps {
  to: string;
  children: React.ReactNode;
}

export function MobileAgentRouteRedirect({ to, children }: MobileAgentRouteRedirectProps) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return <Navigate to={to} replace />;
  }

  return <>{children}</>;
}

export function MobileAgentDetailRedirect({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();
  const { agentSlug } = useParams<{ agentSlug: string }>();
  if (isMobile && agentSlug) {
    return <Navigate to={`/dashboard/agents/mobile/${agentSlug}`} replace />;
  }

  return <>{children}</>;
}

export function MobileAgentRunRedirect({
  agentSlug,
  children,
}: {
  agentSlug: string;
  children: React.ReactNode;
}) {
  const isMobile = useIsMobile();
  if (isMobile && MOBILE_ENABLED_AGENT_IDS.has(agentSlug)) {
    return <Navigate to={`/dashboard/agents/mobile/${agentSlug}/run`} replace />;
  }

  return <>{children}</>;
}
